import React, { PureComponent } from "react";
import logo from "./logoMKrounded.png";
import "./Layout.css";
import Loader from "../Loader/Loader";
import NavItem from "../NavItem/NavItem";
import { BrowserRouter as Router } from "react-router-dom";
import AnimationRoute from "../AnimationRoute/AnimationRoute";
import { AppContext } from "../../context/AppContext";
import TelemetryProvider from "../../telemetry/TelemetryProvider";

interface ILayoutState {
  isLayoutLoading: boolean
  isLoading: boolean;
  pageActive: string;
}

class Layout extends PureComponent<{}, ILayoutState> {
  constructor(props: ILayoutState) {
    super(props);
    this.state = { isLayoutLoading: true, isLoading: true, pageActive: "" };
  }

  loadedChanged = (isLoading: boolean, pageId?: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      const pageActive: string = isLoading && pageId
        ? pageId
        : this.state.pageActive
      this.setState({ isLoading: isLoading, pageActive: pageActive }, () => resolve());
    });
  }

  componentDidMount() {
    process.nextTick(() => {
      this.setState({ isLayoutLoading: false });
    });
  }

  render() {
    return (
      <div className="app">
        <AppContext.Provider
          value={{
            isLoading: this.state.isLoading,
            activePage: this.state.pageActive,
            loadedChanged: this.loadedChanged
          }}>
          <Loader isLoading={this.state.isLayoutLoading} />
          <Router>
            <TelemetryProvider>
              <div>
                <div className="container">
                  <NavItem label="ABOUT" pageId="about" />
                  <NavItem label="BLOG" pageId="blog" />
                  <div className="nav-logo">
                    <img src={logo} className="nav-logo-img" alt="logo" />
                  </div>
                  <NavItem label="IDEAS" pageId="ideas" />
                  <NavItem label="PROJECTS" pageId="projects" />
                </div>

                <AnimationRoute />
              </div>
            </TelemetryProvider>
          </Router>
        </AppContext.Provider>
      </div>
    )
  }
}

export default Layout;
